
const uxLicense0 = 'Uniscope Research and Development, Inc.:OEM:Uniscope Cloud Service::B+:AMS(20260324):6BA5F43D0417A80A4360B13AC9A2537860616FABCF484A7B7C546DA4085430A02ACA31F5C7';
const uxLicense = 'Uniscope Research and Development Inc :OEM:Uniscope Cloud Service::B+:AMS(20290324):3BA5B53D0417A80AA360B13AC9A2537860616FABCF484A7B7C546DA4085430A02ACA31F5C7';

export { uxLicense };
